"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Price = void 0;
var _presentationUtils = require("@ori/presentation-utils");
var _react = require("react");
var _common = require("../../common");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Price = ({
  currentPrice,
  mrpText,
  oldPrice
}) => {
  const showOldPrice = (0, _react.useMemo)(() => oldPrice != null && currentPrice != null && (0, _presentationUtils.parseNumberFromString)(oldPrice) > (0, _presentationUtils.parseNumberFromString)(currentPrice), [currentPrice, oldPrice]);
  if (!currentPrice) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.PriceRoot, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CurrentPrice, {
      "data-testid": _common.PRODUCT_TILE_CURRENT_PRICE,
      isOffer: showOldPrice,
      children: currentPrice
    }), showOldPrice ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.OldPrice, {
      "data-testid": _common.PRODUCT_TILE_OLD_PRICE,
      children: [mrpText ? `${mrpText} ` : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("s", {
        children: oldPrice
      })]
    }) : null]
  });
};
exports.Price = Price;
